import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  cantConnectBankStatementDetailsText: {
    id: "funding-application: reconnect air bank statement details text",
    defaultMessage:
      "You can't connect your bank account, you will therefore need to upload your bank statements to continue.",
  },
});
